const it_messages = require('./it/messages.json')

const ITALIAN_STRINGS = {
  translation: it_messages
}

export default ITALIAN_STRINGS
